<div class="container">

  <div class="box">
    <h3>Кнопка загрузки файлов (pa-uploadfile-button)</h3>

    <form [formGroup]="form">
      <pa-uploadfile-button
        label="Загрузка файлов"
        formControlName="filesButton"
        [acceptedFiles]="allowedFileTypes"
        [maxFileSizeMB]="maxSize"
      ></pa-uploadfile-button>
    </form>
  </div>

  <div class="box">
    <h3>Мини компонент для загрузки</h3>
    <pa-uploadfile
      label="Загрузка файлов"
      [isMini]="true"
      [acceptedFiles]="allowedFileTypes"
      [multiple]="true"
    >
    </pa-uploadfile>
  </div>

  <div class="box">
    <h3>Пустой компонент для загрузки</h3>
    <pa-uploadfile
      label="Загрузка файлов"
      tooltip="Уточняющая информация"
      [acceptedFiles]="allowedFileTypes"
      [multiple]="true"
    >
    </pa-uploadfile>
  </div>

  <div class="box">
    <h3>Компонент с предзагруженными файлами</h3>
    
    <form [formGroup]="form" >
    <pa-uploadfile
      formControlName="files"
      [acceptedFiles]="allowedFileTypes"
      [multiple]="true"
    >
    </pa-uploadfile>
    </form>
  </div>
</div>